<template>
  <div class="login ResetPass">

    <section id="servicios" class="secciones seccion-blanca">
      <div class="row justify-content-center">
        <div class="col-xl-6">
          <createAccount v-if="isSignUp"></createAccount>

          <div v-if="notShow">
            <form @submit.prevent="login" v-if="!isSignUp">
              <h1>
                <strong>Iniciar Sesión</strong>
              </h1>
              <br/>
              <br/>

              <div class="form-group row">
                <label for="staticEmail" class="col-sm-2 col-form-label">Usuario</label>
                <div class="col-sm-10">
                  <input
                    type="text"
                    id="email"
                    class="form-control"
                    v-model="username_form"
                    placeholder="Nombre de usuario o e-mail"
                    required
                    autocomplete="email"
                    autofocus="true"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="inputPassword" class="col-sm-2 col-form-label">Contraseña</label>
                <div class="col-sm-10">
                  <input
                    type="password"
                    autocomplete="off"
                    id="password"
                    v-model="password_form"
                    class="form-control"
                    placeholder="Contraseña"
                    required
                  />
                </div>
              </div>

              <p class="text-muted">
                <span>
                  <a href="javascript:;;" @click="forget_password">¿Olvidaste tu contraseña?</a>
                </span>
              </p>
              <div class="form-group text-center">
                <button class="btn btn-lg btn-primary btn-block" type="submit">
                  <i class="fa fa-spinner fa-spin mr-1" v-if="showLoader"></i> Entrar
                </button>
              </div>
            </form>

            <p class="mt-3 text-muted">
              <span v-if="isSignUp">
                ¿Ya estás registrado?
                <a href="javascript:;;" @click="toggleForm">Iniciar Sesión</a>
              </span>
              <span v-if="!isSignUp">
                ¿Aún no estás registrado?
                <a href="javascript:;;" @click="toggleForm">Crea una cuenta</a>
              </span>
            </p>

            <div :class="[(mensaje === '') ? 'd-none' : 'alert alert-success']" role="alert">
              <button type="button" class="close" data-dismiss="alert" @click="ocultar()">&times;</button>
              <strong>{{ mensaje }}</strong>
            </div>
            <div :class="[(mensaje_error === '') ? 'd-none' : 'alert alert-danger']" role="alert">
              <button type="button" class="close" data-dismiss="alert" @click="ocultar()">&times;</button>
              <strong>{{ mensaje_error }}</strong>
            </div>
          </div>

         

          <form class="form-signin" @submit.prevent="forget_password" v-if="!notShow">

             <template v-if="reset_pass==false">

            <img class="mb-4" src="@/assets/login-img.png" alt width="72" height="72" />
            <h1 class="h3 mb-3 font-weight-normal">¿Olvidó su contraseña?</h1>
            <label>Ingrese su e-mail:</label>
            <label for="email2" class="sr-only">E-mail</label>
            <input
              type="text"
              id="email2"
              class="form-control"
              v-model="username_form"
              placeholder="E-mail"
              required
            />

            <br />
            <button class="btn btn-lg btn-primary btn-block" type="submit">
              <i class="fa fa-spinner fa-spin mr-1" v-if="showLoader"></i> Restablecer Contraseña
            </button>

            <p class="mt-3 text-muted">
              <span>
                ¿Ya estás registrado?
                <a data-toggle="modal" data-target="#myModal2" href>Iniciar Sesión</a>
              </span>
            </p>

            </template>
            <template v-else>
              <h2>Su password fue restablecido, inicie sesión nuevamente.</h2>
              <br>
              <br>
            </template>

            <div :class="[(mensaje === '') ? 'd-none' : 'alert alert-success']" role="alert">
              <button type="button" class="close" data-dismiss="alert" @click="ocultar()">&times;</button>
              <strong>{{ mensaje }}</strong>
            </div>
            <div :class="[(mensaje_error === '') ? 'd-none' : 'alert alert-danger']" role="alert">
              <button type="button" class="close" data-dismiss="alert" @click="ocultar()">&times;</button>
              <strong>{{ mensaje_error }}</strong>
            </div>
          </form>

          
        </div>
      </div>
    </section>
    <TwoModules></TwoModules>
    <Guia></Guia>
  </div>
</template>
<script>
import TwoModules from "@/components/products/TwoModules.vue";
import Guia from "@/components/products/Guia.vue";
import axios from "axios";
import { mapState, mapActions, mapMutations } from "vuex";
import CreateAccount from "@/components/CreateAccount";
import { encryptUser } from "@/components/shared/service/authService";
import {
  successToaster,
  errorToaster
} from "@/components/shared/service/ErrorHandler.js";
import { config_settings } from "@/config.js";

//HTTP ERROR STATUS
const NOT_FOUND = 404;
const BAD_REQUEST = 400;
const UNAUTHORIZED = 401;
const CONFLICT = 409;
const INTERNAL_SERVER_ERROR = 500;

export default {
  name: "login",
  components: { CreateAccount, TwoModules, Guia },
  data() {
    return {
      username_form: "",
      password_form: "",
      showLoader: false,
      isSignUp: false,

      mensaje: "",
      mensaje_error: "",
      notShow: false,
      reset_pass: false
    };
  },
  methods: {
    ...mapMutations(["ADD_LOGGED_USER"]),

    toggleForm() {
      this.notShow = true;
      this.isSignUp = !this.isSignUp;
    },

    showLoginForm() {
      this.notShow = true;
      this.ocultar();
    },

    forget_password() {
      this.reset_pass = false
      if (this.username_form == "") {
        this.notShow = false;
      } else {
        var json_data = {
          cli_username: this.username_form
        };

        axios({
          method: "PUT",
          url: config_settings.RESOURCE_SERVER_URL + "/PUT/forget_password",
          data: json_data
        })
          .then(response => {
            this.reset_pass = true
            this.mensaje =
              "¡Exito! Su contraseña ha sido restablecida correctamente. Por favor, verifique su correo electrónico.";
            /*toastr.success('¡Exito! Su contraseña ha sido restablecida correctamente. Por favor, verifique su correo electrónico asociado a esta cuenta y recomendamemos encarecidamente que cambie la contraseña generada.', 
                        "ÉXITO", {"iconClass": 'customer-success'}); */
          })
          .catch(error => {
            console.log("hOLA:" + error);
            this.mensaje = "";
            this.mensaje_error =
              "Hubo un problema al generar la nueva contraseña. Verifique si ingreso su usuario correctamente e intentelo nuevamente.";
            /*toastr.error(error.response.data.details,
                      error.response.data.message,
                      {"iconClass": 'customer-danger'});*/
          });
      }
    },

    login(event) {
      this.showLoader = true;
      var body_credentials = new FormData();
      body_credentials.append("grant_type", "password");
      body_credentials.append("username", this.username_form);
      body_credentials.append("password", this.password_form);
      body_credentials.append("id_store", config_settings.STORE);

      axios({
        method: "post",
        url: config_settings.AUTH_SERVER_URL + "/oauth/token",
        data: body_credentials,
        withCredentials: true,
        auth: {
          username: "USER_CLIENT_APP",
          password: "password"
        }
      })
        .then(response => {
          var token = response.data.access_token;
          var refresh_token = response.data.refresh_token;
          localStorage.setItem("access_token", token);
          localStorage.setItem("refresh_token", refresh_token);

          this.showLoader = false;
          event.target.reset();
          //this.$router.push(this.$route.query.from || "/");
          //location.reload();
          location.href = "/";
          console.log("sesion correctamente");
        })
        .catch(error => {
          this.showLoader = false;
          this.mensaje_error =
            "Clave y/o usuario no coinciden. Ingrese nuevamente su usuario y contraseña.";

          //console.log(error);
        });
    },

    ocultar() {
      this.mensaje = "";
      this.mensaje_error = "";
    }
  }
};
</script>

<style lang="scss" src="./ResetPass.scss"></style>
